import { set } from 'mobx';
import { IAccessRequestResponse } from '~/types/server.types';

import type { User } from '~/models/user.model';
import { AccountAccessAuthorization } from '~/models/account-access-request.model';
import type { Company } from '~/models/company.model';

const BOOKKEEPER_EXPIRATION_DAYS = 365;

export class BookkeeperAccountAccessAuthorization extends AccountAccessAuthorization {
    company: Company;
    bookkeeper_user: User;

    constructor(request: IAccessRequestResponse) {
        super(request);
        set(this, request);
    }

    get expirationDays() {
        return BOOKKEEPER_EXPIRATION_DAYS;
    }
}
